import { object, string, type InferType } from 'yup';

export const studentSearchSchema = object({
  q: string().trim().default(''),
});

export type StudentSearchFormValues = InferType<typeof studentSearchSchema>;
